export default "__VITE_ASSET__DuQ5E707__"